// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ac6b24d8","703":"83af5ec9","787":"7ac09ba0"}[chunkId] + ".chunk.js";
};